export function capitalize(input: string): string {
  return input.charAt(0).toUpperCase() + input.substring(1);
}

export function uncapitalize<S extends string>(input: S): Uncapitalize<S> {
  return (input.substring(0, 1).toLowerCase() +
    input.substring(1)) as Uncapitalize<S>;
}

export function withEnv(input: string, env = "") {
  return env === "prod" || !env ? input : `${input} (${env.toUpperCase()})`;
}

export function isOnlyNumbers(str: string) {
  return /^\d+$/.test(str);
}

export function removeStopNameSuffixes(stopName: string): string {
  return stopName.replace(/ \w*(stasjon|station)\s*$/i, "");
}

export const normalizeScandinavianCharacters = (input: string) =>
  input
    .replace(/ä|æ/g, "ae")
    .replace(/ö|ø/g, "o")
    .replace(/Ä|Æ/g, "Ae")
    .replace(/Ö|Ø/g, "O");
